import { render, staticRenderFns } from "./MyTasks.vue?vue&type=template&id=f95c4fb8&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"
import style0 from "./MyTasks.vue?vue&type=style&index=0&id=f95c4fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95c4fb8",
  null
  
)

export default component.exports